import React, {useState} from 'react';
import Icon from "../../Icon";
import {Button} from "../../Button";
import Avatar from "../../Avatar";
import logo_gmail from "../../../../images/logo-gmail.png";
import logo_yaoo from "../../../../images/logo-yahoo.png";
import logo_outlook from "../../../../images/logo-outlook.png";
import logo_orange from "../../../../images/logo-orange.png";
import logo_laposte from "../../../../images/logo-laposte.png";
import Modal from "../../Modal";
import _ from 'lodash';
import createLink from "../../../../libs/createLink";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {
    sendEnrollmentEmailCurrentUser,
    updateEmailCurrentUser,
    USER_CURRENT_KEY
} from "../../../../api/public-voissa/users";
import {Navigate} from "react-router-dom";
import {toastError, toastSuccess} from "../../../../libs/toast";
import {CURRENT_USER, MAIL} from "../../../../const/toasts";

function webmail(currentEmail) {
    if (currentEmail) {
        let domain = currentEmail.substring(currentEmail.indexOf("@") + 1, currentEmail.lastIndexOf("."));
        let webmail = {
            "gmail" : {
                image: logo_gmail,
                href: "https://www.gmail.com"
            },
            "yahoo" : {
                image: logo_yaoo,
                href: "https://mail.yahoo.com"
            },
            "hotmail" : {
                image: logo_outlook,
                href: "https://outlook.com"
            },
            "live" : {
                image: logo_outlook,
                href: "https://outlook.com"
            },
            "outlook" : {
                image: logo_outlook,
                href: "https://outlook.com"
            },
            "orange" : {
                image: logo_orange,
                href: "https://messagerie.orange.fr"
            },
            "wanadoo" : {
                image: logo_orange,
                href: "https://messagerie.orange.fr"
            },
            "laposte" : {
                image: logo_laposte,
                href: "https://www.laposte.net/accueil"
            }
        };
        return webmail[domain] || false;
    }
    return false
}

const EmailValidation = ({
         toggle = false,
         handleClose = () =>{},
         signup = {},
         isModal = false
     }) => {
    return isModal ? (
        <Modal toggle={toggle} handleClose={() => handleClose()}>
            <EmailValidation2
                toggle={toggle}
                handleClose={handleClose}
                signup={signup}
            />
        </Modal>
    ) : (
        <EmailValidation2
            toggle={toggle}
            handleClose={handleClose}
            signup={signup}
        />
    )
}


const EmailValidation2 = ({
        toggle = false,
        handleClose = () =>{},
        signup = {},
    }) =>{

    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    let initEmail = _.get(dataCurrentUser, 'email.address') || "";

    const [showUpdateEmail, setShowUpdateEmail] = useState(false);
    const [isSendMail, setIsSendMail] = useState(false);
    const [currentEmail, setCurrentEmail] = useState(initEmail);

    if(!signup){
        sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
    }

    const {
        mutate : mutateSendEnrollmentEmail,
    } = useMutation(() => sendEnrollmentEmailCurrentUser(),{
        onSuccess: async () =>{
            toastSuccess(MAIL.SUCCESS.SEND_ENROLLMENT);
        },
        onError: () =>{
            toastError(MAIL.ERROR.SEND_ENROLLMENT);
        }
    });

    const {
        mutate : mutateUpdateEmail,
    } = useMutation((data) => updateEmailCurrentUser(data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([USER_CURRENT_KEY]);
        },
        onError: () =>{
            toastError(CURRENT_USER.ERROR.UPDATE);
        }
    });


    function sendMail(){
        if(!isSendMail){
            mutateSendEnrollmentEmail();
            setIsSendMail(true);
            setTimeout(() =>setIsSendMail(false), 10000);
        }

    }

    function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        setShowUpdateEmail(false);
        mutateUpdateEmail({email: currentEmail});

    }

    if(!isCurrentUser && toggle){
        return <Navigate to={createLink("signin")} />;
    }

    let ctaEmail = webmail();
    return (

        <div id={"emailValidation"}>
            <div className={"container"}>
                <div className={"card"}>
                    <div className={"email-topline"}>
                        <div className={"icon-wrapper"}><Icon type={"confetti"}/></div>
                        <span className={"validate-email"}>Bienvenue sur Voissa !</span>
                    </div>
                    {_.get(dataCurrentUser,"role") === "emailUnconfirmed" ? (
                        <>
                            <form className={"content"} onSubmit={(e) => handleSubmit(e)}>
                                <Avatar gender={dataCurrentUser.profile && dataCurrentUser.profile.gender} avatar={dataCurrentUser.profile && dataCurrentUser.profile.avatar}/>
                                <span className={"username"}>{dataCurrentUser.username}</span>
                                {signup.error && signup.error.errors && signup.error.errors.email ? <span className="warning">{signup.error.errors.email}</span> : <span className={"check-email"}>Vous devez confirmer votre inscription en cliquant sur le lien de vérification qui a été envoyé par email à <span
                                    className={"my-email"}>
                                    {ctaEmail ? (<a href={ctaEmail.href} target={"_blank"} rel="noopener noreferrer nofollow">{currentEmail || _.get(dataCurrentUser, "email.address")}</a>) : currentEmail || _.get(dataCurrentUser, "email.address") }
                                </span></span>}

                                {ctaEmail ? (
                                        <span className={"username"}><a href={ctaEmail.href} target={"_blank"} rel="noopener noreferrer nofollow">
                                            <img src={ctaEmail.image} alt={"Voir vos Emails"}/> </a>
                                        </span>)
                                : null}
                                {showUpdateEmail ? (
                                    <>
                                        <span className={"email-not-received"}>Votre nouvelle adresse email</span>
                                        <input type={"email"} required={true}
                                               onChange={(event) => setCurrentEmail(event.target.value)}
                                               className={"email-not-received"} placeholder={"Votre Adresse Email"}/>
                                        <div className={"modify-email-btn-group"}>
                                            <Button btnStyle={"grey"}
                                                    size={"small"}
                                                    onClick={() => {setShowUpdateEmail(false); setCurrentEmail(initEmail)}}
                                                    content={"Annuler"}/>
                                            <Button btnStyle={"primary-reverse"}
                                                    btnType={"submit"}
                                                    size={"small"}
                                                    content={"Enregistrer"}/>
                                        </div>
                                    </>
                                ) : (
                                    signup.error && signup.error.errors && signup.error.errors.email ?
                                        <><span className={"separator"}> </span><div className={"email-modifications-btn"}
                                                                                             onClick={() => setShowUpdateEmail(true)}>modifier l'email
                                        </div></>
                                        : (<>
                                            <span className={"email-not-received"}>Vous n’avez pas reçu l’email?</span>
                                            <div className={"email-modifications-btn"} onClick={() =>sendMail()}>Renvoyer l'email d'activation</div>
                                            {isSendMail ? (<div className={"success"}>Un nouvel e-mail vient de partir</div>) : null }
                                            <span className={"separator"}>ou</span>
                                            <div className={"email-modifications-btn"}
                                                 onClick={() => setShowUpdateEmail(true)}>modifier l'email
                                            </div>
                                        </>)
                                )}
                            </form>
                            <div className={"email-informations"}>
                                <ul>
                                    <li>Pensez à vérifier vos spams.</li>
                                    <li>Si vous ne recevez pas l’email après 10 minutes, veuillez <a
                                        href={"/contact"}>contacter</a> notre support
                                    </li>
                                </ul>
                            </div>

                        </>
                    ) : (
                        <div className={"load-page p-16"}>Votre compte est confirmé<br />Vous allez pouvoir utiliser toutes les options d'ici quelques secondes...</div>
                    )}
                    <Button size="medium"
                            onClick={() => handleClose()}
                            btnStyle="grey"
                            content="Fermer"/>
                </div>
            </div>
        </div>
    )
};

export default EmailValidation;